import { render } from "./HorizontalSpotCardSlide.vue?vue&type=template&id=16438cb7&scoped=true"
import script from "./HorizontalSpotCardSlide.vue?vue&type=script&lang=js"
export * from "./HorizontalSpotCardSlide.vue?vue&type=script&lang=js"

import "./HorizontalSpotCardSlide.vue?vue&type=style&index=0&id=16438cb7&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src1700309314/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16438cb7"]])

export default __exports__